import { datasetSubscriptions } from './constants';

const allowSubscribersRead = (category, { permissions }) => ({
  dataset: permissions.datasets.read,
}[category]);

export const defaultEvent = (category) => ({
  dataset: datasetSubscriptions.DATASET_UPDATE,
})[category];

export default allowSubscribersRead;
